import FootTC from '../comps/FootTC';
import B from '../compsAu/B';
import Banner from '../compsAu/Banner';
import C from '../compsAu/C';
import Compare from '../compsAu/Compare';
import G from '../compsAu/G';
import H from '../compsAu/H';
import I from '../compsAu/I';
import J from '../compsAu/J';
import K from '../compsAu/K';
import M from '../compsAu/M';
import TabA from '../compsAu/TabA';
import Users from '../compsAu/Users';
import WhatInBox from '../compsAu/WhatInBox';
import ListA from '../compsNa/ListA';
import ListB from '../compsNa/ListB';
import SectionB from '../compsNa/SectionB';
import SectionC from '../compsNa/SectionC';
import L from './NewComps/L';
import styles from './ProductContent.module.scss';

export default function ProductAu() {
    return (
        <div className={styles.teaser}>
            <Banner />
            <B />
            {/* <SectionA /> */}
            <I />
            <G />
            <H />
            <J />
            <M />
            <C />
            <K />
            <L />
            <SectionB />
            <SectionC />
            <TabA />
            <Compare />
            <ListA />
            <ListB />
            <WhatInBox />
            <Users />
            <FootTC />
        </div>
    );
}
